/**
 * File: useCmsGlanceController.ts
 * Path: apps/admin/src/features/menu/hooks/useCmsGlanceController.ts
 * Description: The CMS line on a section's page: how many case studies and articles are still drafts.
 */

import { useProjectsQueries } from "@/shared/hooks/useProjectsQueries";
import { useAcademyQueries } from "@/shared/hooks/useAcademyQueries";
import { countDrafts, draftsText } from "@/features/menu/utils/glanceUtils";

export const useCmsGlanceController = () => {
  const projects = useProjectsQueries().useList();
  const articles = useAcademyQueries().useList();
  if (!projects.data && !articles.data) return { loaded: false, drafts: 0, text: "" };
  const caseStudies = countDrafts(projects.data);
  const posts = countDrafts(articles.data);
  return { loaded: true, drafts: caseStudies + posts, text: draftsText(caseStudies, posts) };
};
